import { css, keyframes } from 'styled-components';

const loadingKeyframes = keyframes`
  100% {
    transform: translateX(100%);
  }
`;

const loadingKeyframesRules = css`
  ${loadingKeyframes} 1.5s infinite;
`;

const listHeaderStyles = css`
  height: 32px;
  background-color: var(--grey200);
  color: var(--grey900);
  font-weight: bold;
  padding: 0 8px;
  display: flex;
  align-items: center;

  position: sticky;
  top: 0;

  .day {
    margin-right: 5px;
  }

  &__loading {
    position: relative;
    opacity: 0.5;
    &:after {
      display: block;
      content: '';
      position: absolute;
      width: 100%;
      height: 100%;
      transform: translateX(-100%);
      background: linear-gradient(90deg, transparent, rgba(0, 0, 0, 0.1), transparent);
      animation: ${loadingKeyframesRules};
    }
  }
`;

export default listHeaderStyles;
